import { $ } from '@/libs/jquery/index'
import { mainCfgWithImgSettings as main} from '@/libs/tinymce/utils/cfg_main_with_img.ts'
import { getUploadImagePath, uploadHandler } from '@/libs/tinymce/utils/index.ts'
import { crmPostFormSelector } from '@/views/crm/info_item/posts/form/index'

const uploadPostHandler = (blobInfo, success, failure) => {
  const postId: string = $(crmPostFormSelector).data('id')
  const hint = JSON.stringify({ id: postId, type: 'info_item/posts' })
  uploadHandler(blobInfo, success, failure, getUploadImagePath, hint)
}

// Настройки для статей
// /crm/info_item/posts/post_id/edit/
export const postSettings = {
  ...main,
  images_upload_handler: uploadPostHandler,
}
